import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TeacherStatus,
  updateTeacherStatus,
} from "../../services/teacher.service";
import Button from "../../components/buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import showToast from "../../utils/show.toast";
import "./statusStyle.scss";

interface ITeacherStatus {
  status: TeacherStatus;
  teacherId: string | undefined;
  redirectUrl: string;
  currentStatus: string;
}

const RenderDetailButton = ({
  redirectUrl,
  currentStatus,
  status,
  teacherId,
}: ITeacherStatus) => {
  const [action, setAction] = useState<string | null>(null);
  const navigation = useNavigate();

  const update = async (statusToUpdate: TeacherStatus, actionName: string) => {
    setAction(actionName);

    try {
      const endpoint = `teachers/teacher-status/${teacherId}`;
      await updateTeacherStatus(endpoint, { status: statusToUpdate });
      showToast(
        `Teacher ${statusToUpdate.toLocaleLowerCase()} successfully!`,
        true
      );
      setAction(null);

      return navigation(`${redirectUrl}?status=${currentStatus}`);
    } catch (error) {
      setAction(null);
      const message =
        error instanceof Error
          ? error.message
          : "Apologies, an unexpected error occured!";
      showToast(message, false);
    }
  };

  return (
    <div className={`teacher-status ${status.toLowerCase()}`}>
      <div className="teacher-status-badge">
        <FontAwesomeIcon icon={faAward} className="teacher-icon" />
        <h5>
          {status === TeacherStatus.REGISTERED && "Unreviewed Teacher"}
          {status === TeacherStatus.ACCEPTED && "Reviewed Teacher"}
          {status === TeacherStatus.VERIFIED && "Verified Teacher"}
          {status === TeacherStatus.SUSPENDED && "Suspended Teacher"}
        </h5>
      </div>

      <div className="teacher-status-actions">
        {status === TeacherStatus.REGISTERED && (
          <>
            <Button
              name="Approve"
              type="activate-button"
              isLoading={action === "approve"}
              loadingText="Approving..."
              onClick={() => update(TeacherStatus.ACCEPTED, "approve")}
            />
            <Button
              name="Reject"
              type="delete-button"
              isLoading={action === "reject"}
              loadingText="Rejecting..."
              onClick={() => update(TeacherStatus.REJECTED, "reject")}
            />
          </>
        )}

        {status === TeacherStatus.ACCEPTED && (
          <>
            <Button
              name="Verify"
              type="activate-button"
              isLoading={action === "verify"}
              loadingText="Verifying..."
              onClick={() => update(TeacherStatus.VERIFIED, "verify")}
            />
            <Button
              name="Reject"
              type="delete-button"
              isLoading={action === "reject"}
              loadingText="Rejecting..."
              onClick={() => update(TeacherStatus.REJECTED, "reject")}
            />
          </>
        )}

        {status === TeacherStatus.VERIFIED && (
          <Button
            name="Suspend"
            type="activate-button"
            isLoading={action === "suspend"}
            loadingText="Suspending..."
            onClick={() => update(TeacherStatus.SUSPENDED, "suspend")}
          />
        )}

        {status === TeacherStatus.SUSPENDED && (
          <>
            <Button
              name="Approve"
              type="activate-button"
              isLoading={action === "approve"}
              loadingText="Approving..."
              onClick={() => update(TeacherStatus.ACCEPTED, "approve")}
            />
            <Button
              name="Deactivate"
              type="delete-button"
              isLoading={action === "deactivate"}
              loadingText="Deactivating..."
              onClick={() => update(TeacherStatus.DEACTIVATED, "deactivate")}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default RenderDetailButton;
